import React from 'react'

import { ConfirmModal, useModalContext } from '@fourthwall/components'

import { useOffersDuplicateMutation } from '../../hooks/useOffersDuplicateMutation'
import { useSubscriptionOffers } from '../../modules/Subscriptions'
import type { Offer } from '../SingleProduct/SingleProduct.types'

export const useDuplicateProduct = () => {
  const { open } = useModalContext()
  const {
    shouldShowLimitsModal,
    shouldShowUpgradeModal,
    openSubscriptionOffersLimitModal,
    openSubscriptionOffersUpgradeModal,
  } = useSubscriptionOffers()
  const { duplicateOfferMutation } = useOffersDuplicateMutation()

  const openDuplicateProductModal = ({
    name,
    id,
    onSuccess,
    onError,
  }: {
    name: string
    id: string
    onSuccess: (offer: Offer) => void
    onError?: () => void
  }) => {
    if (shouldShowLimitsModal) {
      openSubscriptionOffersLimitModal()

      return
    }

    if (shouldShowUpgradeModal) {
      openSubscriptionOffersUpgradeModal({
        source: 'duplicate_product',
      })

      return
    }

    open(ConfirmModal, {
      title: 'Duplicate product',
      confirmLabel: 'Duplicate',
      cancelLabel: 'Cancel',
      text: (
        <p>
          Are you sure you want to duplicate <strong>{name}</strong>
        </p>
      ),
      onConfirm: () =>
        duplicateOfferMutation.mutate([{ offerId: id }], {
          onSuccess,
          onError,
        }),
    })
  }

  return {
    openDuplicateProductModal,
    isLoading: duplicateOfferMutation.isLoading,
  }
}
